import {inject, Injectable} from "@angular/core";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Observable} from "rxjs";
import {MephistoPollingResponseDTO} from "../../models/MephistoPollingResponseDTO";

@Injectable({
	providedIn: "root",
})
export class MephistoConnectionService {
	private readonly apiUrl = "/mep/api/mephisto";
	public readonly http = inject(HttpClient);

	uploadRawTextAndPollStaffingRequest(requestData: string): Observable<MephistoPollingResponseDTO> {
		const url = `${this.apiUrl}/uploadRawTextAndPollStaffingRequest`;
		// eslint-disable-next-line @typescript-eslint/naming-convention
		const headers = new HttpHeaders({"Content-Type": "application/json"});

		return this.http.post<MephistoPollingResponseDTO>(url, requestData, {
			headers,
		});
	}

	uploadPdfAndPollStaffingRequest(fileData: FormData): Observable<MephistoPollingResponseDTO> {
		const url = `${this.apiUrl}/uploadPdfAndPollStaffingRequest`;
		return this.http.post<MephistoPollingResponseDTO>(url, fileData);
	}
}
